/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PayoutMember } from '../models/payout-member';

@Injectable({
  providedIn: 'root',
})
export class ExcelService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiExcelExportBankAdviceGet
   */
  static readonly ApiExcelExportBankAdviceGetPath = '/api/Excel/ExportBankAdvice';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExportBankAdviceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportBankAdviceGet$Response(params?: {
    payoutID?: string;
    card_number?: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExportBankAdviceGetPath, 'get');
    if (params) {
      rb.query('payoutID', params.payoutID, {});
      rb.query('card_number', params.card_number, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExportBankAdviceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportBankAdviceGet(params?: {
    payoutID?: string;
    card_number?: number;
  }): Observable<Blob> {

    return this.apiExcelExportBankAdviceGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExportBankAdvice2Get
   */
  static readonly ApiExcelExportBankAdvice2GetPath = '/api/Excel/ExportBankAdvice2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExportBankAdvice2Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportBankAdvice2Get$Response(params?: {
    payoutID?: string;
    card_number?: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExportBankAdvice2GetPath, 'get');
    if (params) {
      rb.query('payoutID', params.payoutID, {});
      rb.query('card_number', params.card_number, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExportBankAdvice2Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportBankAdvice2Get(params?: {
    payoutID?: string;
    card_number?: number;
  }): Observable<Blob> {

    return this.apiExcelExportBankAdvice2Get$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelGmdGet
   */
  static readonly ApiExcelExcelGmdGetPath = '/api/Excel/Excel_GMD';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelGmdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGmdGet$Response(params?: {
    payoutID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelGmdGetPath, 'get');
    if (params) {
      rb.query('payoutID', params.payoutID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelGmdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGmdGet(params?: {
    payoutID?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelGmdGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelGmd2Get
   */
  static readonly ApiExcelExcelGmd2GetPath = '/api/Excel/Excel_GMD2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelGmd2Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGmd2Get$Response(params?: {
    payoutID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelGmd2GetPath, 'get');
    if (params) {
      rb.query('payoutID', params.payoutID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelGmd2Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGmd2Get(params?: {
    payoutID?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelGmd2Get$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelSingleBillingGet
   */
  static readonly ApiExcelExcelSingleBillingGetPath = '/api/Excel/Excel_SingleBilling';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSingleBillingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSingleBillingGet$Response(params?: {
    billing_id?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelSingleBillingGetPath, 'get');
    if (params) {
      rb.query('billing_id', params.billing_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSingleBillingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSingleBillingGet(params?: {
    billing_id?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelSingleBillingGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelBillingGet
   */
  static readonly ApiExcelExcelBillingGetPath = '/api/Excel/Excel_Billing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelBillingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingGet$Response(params?: {
    TITLE?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelBillingGetPath, 'get');
    if (params) {
      rb.query('TITLE', params.TITLE, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelBillingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingGet(params?: {
    TITLE?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelBillingGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelBillingNoPositionGet
   */
  static readonly ApiExcelExcelBillingNoPositionGetPath = '/api/Excel/Excel_BillingNoPosition';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelBillingNoPositionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingNoPositionGet$Response(params?: {
    TITLE?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelBillingNoPositionGetPath, 'get');
    if (params) {
      rb.query('TITLE', params.TITLE, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelBillingNoPositionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingNoPositionGet(params?: {
    TITLE?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelBillingNoPositionGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelBillingCnxGet
   */
  static readonly ApiExcelExcelBillingCnxGetPath = '/api/Excel/Excel_BillingCNX';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelBillingCnxGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingCnxGet$Response(params?: {
    TITLE?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelBillingCnxGetPath, 'get');
    if (params) {
      rb.query('TITLE', params.TITLE, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelBillingCnxGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingCnxGet(params?: {
    TITLE?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelBillingCnxGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelSingleBillingNoPositionGet
   */
  static readonly ApiExcelExcelSingleBillingNoPositionGetPath = '/api/Excel/Excel_SingleBillingNoPosition';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSingleBillingNoPositionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSingleBillingNoPositionGet$Response(params?: {
    billing_id?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelSingleBillingNoPositionGetPath, 'get');
    if (params) {
      rb.query('billing_id', params.billing_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSingleBillingNoPositionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSingleBillingNoPositionGet(params?: {
    billing_id?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelSingleBillingNoPositionGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelExportDisbursementAdviceGet
   */
  static readonly ApiExcelExcelExportDisbursementAdviceGetPath = '/api/Excel/ExcelExport_DisbursementAdvice';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportDisbursementAdviceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDisbursementAdviceGet$Response(params?: {
    date1?: string;
    date2?: string;
    tran_type?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelExportDisbursementAdviceGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
      rb.query('tran_type', params.tran_type, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportDisbursementAdviceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDisbursementAdviceGet(params?: {
    date1?: string;
    date2?: string;
    tran_type?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelExportDisbursementAdviceGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelExportSingleDeductionReportGet
   */
  static readonly ApiExcelExcelExportSingleDeductionReportGetPath = '/api/Excel/ExcelExport_SingleDeductionReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportSingleDeductionReportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportSingleDeductionReportGet$Response(params?: {
    date1?: string;
    date2?: string;
    tran_type?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelExportSingleDeductionReportGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
      rb.query('tran_type', params.tran_type, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportSingleDeductionReportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportSingleDeductionReportGet(params?: {
    date1?: string;
    date2?: string;
    tran_type?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelExportSingleDeductionReportGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExportXlsx2Get
   */
  static readonly ApiExcelExportXlsx2GetPath = '/api/Excel/ExportXlsx2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExportXlsx2Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportXlsx2Get$Response(params?: {
    payoutID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExportXlsx2GetPath, 'get');
    if (params) {
      rb.query('payoutID', params.payoutID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExportXlsx2Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportXlsx2Get(params?: {
    payoutID?: string;
  }): Observable<Blob> {

    return this.apiExcelExportXlsx2Get$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExportXlsxGet
   */
  static readonly ApiExcelExportXlsxGetPath = '/api/Excel/ExportXlsx';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExportXlsxGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportXlsxGet$Response(params?: {
    payoutID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExportXlsxGetPath, 'get');
    if (params) {
      rb.query('payoutID', params.payoutID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExportXlsxGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportXlsxGet(params?: {
    payoutID?: string;
  }): Observable<Blob> {

    return this.apiExcelExportXlsxGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelPayoutTemplatePost
   */
  static readonly ApiExcelPayoutTemplatePostPath = '/api/Excel/PayoutTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelPayoutTemplatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelPayoutTemplatePost$Response(params?: {
    body?: Array<PayoutMember>
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelPayoutTemplatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelPayoutTemplatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelPayoutTemplatePost(params?: {
    body?: Array<PayoutMember>
  }): Observable<Blob> {

    return this.apiExcelPayoutTemplatePost$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelTopsheetTemplatePost
   */
  static readonly ApiExcelTopsheetTemplatePostPath = '/api/Excel/TopsheetTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelTopsheetTemplatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelTopsheetTemplatePost$Response(params?: {
    body?: Array<PayoutMember>
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelTopsheetTemplatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelTopsheetTemplatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelTopsheetTemplatePost(params?: {
    body?: Array<PayoutMember>
  }): Observable<Blob> {

    return this.apiExcelTopsheetTemplatePost$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelCheckVoucherGet
   */
  static readonly ApiExcelCheckVoucherGetPath = '/api/Excel/CheckVoucher';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelCheckVoucherGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelCheckVoucherGet$Response(params?: {
    ENTRY_ID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelCheckVoucherGetPath, 'get');
    if (params) {
      rb.query('ENTRY_ID', params.ENTRY_ID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelCheckVoucherGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelCheckVoucherGet(params?: {
    ENTRY_ID?: string;
  }): Observable<Blob> {

    return this.apiExcelCheckVoucherGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelJournalVoucherGet
   */
  static readonly ApiExcelJournalVoucherGetPath = '/api/Excel/JournalVoucher';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelJournalVoucherGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelJournalVoucherGet$Response(params?: {
    ENTRY_ID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelJournalVoucherGetPath, 'get');
    if (params) {
      rb.query('ENTRY_ID', params.ENTRY_ID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelJournalVoucherGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelJournalVoucherGet(params?: {
    ENTRY_ID?: string;
  }): Observable<Blob> {

    return this.apiExcelJournalVoucherGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelGenJournalGet
   */
  static readonly ApiExcelExcelGenJournalGetPath = '/api/Excel/Excel_GenJournal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelGenJournalGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGenJournalGet$Response(params?: {
    date1?: string;
    date2?: string;
    src_journal?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelGenJournalGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
      rb.query('src_journal', params.src_journal, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelGenJournalGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGenJournalGet(params?: {
    date1?: string;
    date2?: string;
    src_journal?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelGenJournalGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelSubsidiaryGet
   */
  static readonly ApiExcelExcelSubsidiaryGetPath = '/api/Excel/Excel_Subsidiary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSubsidiaryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSubsidiaryGet$Response(params?: {
    date1?: string;
    date2?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelSubsidiaryGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSubsidiaryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSubsidiaryGet(params?: {
    date1?: string;
    date2?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelSubsidiaryGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelTrialBalanceGet
   */
  static readonly ApiExcelExcelTrialBalanceGetPath = '/api/Excel/Excel_TrialBalance';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelTrialBalanceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTrialBalanceGet$Response(params?: {
    date1?: string;
    date2?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelTrialBalanceGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelTrialBalanceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTrialBalanceGet(params?: {
    date1?: string;
    date2?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelTrialBalanceGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelTrialBalanceMonthlyGet
   */
  static readonly ApiExcelExcelTrialBalanceMonthlyGetPath = '/api/Excel/Excel_TrialBalanceMonthly';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelTrialBalanceMonthlyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTrialBalanceMonthlyGet$Response(params?: {
    date1?: string;
    date2?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelTrialBalanceMonthlyGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelTrialBalanceMonthlyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTrialBalanceMonthlyGet(params?: {
    date1?: string;
    date2?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelTrialBalanceMonthlyGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelCashReceiptRegisterGet
   */
  static readonly ApiExcelExcelCashReceiptRegisterGetPath = '/api/Excel/Excel_CashReceiptRegister';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelCashReceiptRegisterGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCashReceiptRegisterGet$Response(params?: {
    date1?: string;
    date2?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelCashReceiptRegisterGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelCashReceiptRegisterGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCashReceiptRegisterGet(params?: {
    date1?: string;
    date2?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelCashReceiptRegisterGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelBillingRegisterGet
   */
  static readonly ApiExcelExcelBillingRegisterGetPath = '/api/Excel/Excel_BillingRegister';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelBillingRegisterGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingRegisterGet$Response(params?: {
    date1?: string;
    date2?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelBillingRegisterGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelBillingRegisterGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingRegisterGet(params?: {
    date1?: string;
    date2?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelBillingRegisterGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelCheckDisbursementsGet
   */
  static readonly ApiExcelExcelCheckDisbursementsGetPath = '/api/Excel/Excel_CheckDisbursements';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelCheckDisbursementsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCheckDisbursementsGet$Response(params?: {
    date1?: string;
    date2?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelCheckDisbursementsGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelCheckDisbursementsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCheckDisbursementsGet(params?: {
    date1?: string;
    date2?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelCheckDisbursementsGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelCheckRegisterGet
   */
  static readonly ApiExcelExcelCheckRegisterGetPath = '/api/Excel/Excel_CheckRegister';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelCheckRegisterGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCheckRegisterGet$Response(params?: {
    date1?: string;
    date2?: string;
    accountID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelCheckRegisterGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
      rb.query('accountID', params.accountID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelCheckRegisterGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCheckRegisterGet(params?: {
    date1?: string;
    date2?: string;
    accountID?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelCheckRegisterGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelExportDeductionsGet
   */
  static readonly ApiExcelExcelExportDeductionsGetPath = '/api/Excel/ExcelExport_Deductions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportDeductionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDeductionsGet$Response(params?: {
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelExportDeductionsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportDeductionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDeductionsGet(params?: {
  }): Observable<Blob> {

    return this.apiExcelExcelExportDeductionsGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelExportDeductionsByClientGet
   */
  static readonly ApiExcelExcelExportDeductionsByClientGetPath = '/api/Excel/ExcelExport_DeductionsByClient';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportDeductionsByClientGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDeductionsByClientGet$Response(params?: {
    clientID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelExportDeductionsByClientGetPath, 'get');
    if (params) {
      rb.query('clientID', params.clientID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportDeductionsByClientGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDeductionsByClientGet(params?: {
    clientID?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelExportDeductionsByClientGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelExportSavingsMasterfileGet
   */
  static readonly ApiExcelExcelExportSavingsMasterfileGetPath = '/api/Excel/ExcelExport_SavingsMasterfile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportSavingsMasterfileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportSavingsMasterfileGet$Response(params?: {
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelExportSavingsMasterfileGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportSavingsMasterfileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportSavingsMasterfileGet(params?: {
  }): Observable<Blob> {

    return this.apiExcelExcelExportSavingsMasterfileGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelExportMembersGet
   */
  static readonly ApiExcelExcelExportMembersGetPath = '/api/Excel/ExcelExport_Members';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportMembersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportMembersGet$Response(params?: {
    clientID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelExportMembersGetPath, 'get');
    if (params) {
      rb.query('clientID', params.clientID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportMembersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportMembersGet(params?: {
    clientID?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelExportMembersGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelSavingsLedgerGet
   */
  static readonly ApiExcelExcelSavingsLedgerGetPath = '/api/Excel/Excel_SavingsLedger';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSavingsLedgerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSavingsLedgerGet$Response(params?: {
    date1?: string;
    date2?: string;
    entityID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelSavingsLedgerGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
      rb.query('entityID', params.entityID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSavingsLedgerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSavingsLedgerGet(params?: {
    date1?: string;
    date2?: string;
    entityID?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelSavingsLedgerGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelCoopShareLedgerGet
   */
  static readonly ApiExcelExcelCoopShareLedgerGetPath = '/api/Excel/Excel_CoopShareLedger';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelCoopShareLedgerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCoopShareLedgerGet$Response(params?: {
    date1?: string;
    date2?: string;
    entityID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelCoopShareLedgerGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
      rb.query('entityID', params.entityID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelCoopShareLedgerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCoopShareLedgerGet(params?: {
    date1?: string;
    date2?: string;
    entityID?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelCoopShareLedgerGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelTopsheetReportGet
   */
  static readonly ApiExcelExcelTopsheetReportGetPath = '/api/Excel/Excel_TopsheetReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelTopsheetReportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTopsheetReportGet$Response(params?: {
    topsheetID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelTopsheetReportGetPath, 'get');
    if (params) {
      rb.query('topsheetID', params.topsheetID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelTopsheetReportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTopsheetReportGet(params?: {
    topsheetID?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelTopsheetReportGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelDeductionsLedgerGet
   */
  static readonly ApiExcelExcelDeductionsLedgerGetPath = '/api/Excel/Excel_DeductionsLedger';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelDeductionsLedgerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelDeductionsLedgerGet$Response(params?: {
    date1?: string;
    date2?: string;
    entityID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelDeductionsLedgerGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
      rb.query('entityID', params.entityID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelDeductionsLedgerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelDeductionsLedgerGet(params?: {
    date1?: string;
    date2?: string;
    entityID?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelDeductionsLedgerGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelPayrollWorkedDaysGet
   */
  static readonly ApiExcelExcelPayrollWorkedDaysGetPath = '/api/Excel/Excel_PayrollWorkedDays';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelPayrollWorkedDaysGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPayrollWorkedDaysGet$Response(params?: {
    date1?: string;
    date2?: string;
    clientID?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelPayrollWorkedDaysGetPath, 'get');
    if (params) {
      rb.query('date1', params.date1, {});
      rb.query('date2', params.date2, {});
      rb.query('clientID', params.clientID, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelPayrollWorkedDaysGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPayrollWorkedDaysGet(params?: {
    date1?: string;
    date2?: string;
    clientID?: string;
  }): Observable<Blob> {

    return this.apiExcelExcelPayrollWorkedDaysGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelExcelSomaPost
   */
  static readonly ApiExcelExcelSomaPostPath = '/api/Excel/Excel_SOMA';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSomaPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelExcelSomaPost$Response(params?: {
    body?: Array<string>
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelExcelSomaPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSomaPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelExcelSomaPost(params?: {
    body?: Array<string>
  }): Observable<Blob> {

    return this.apiExcelExcelSomaPost$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation apiExcelPdfSomaGet
   */
  static readonly ApiExcelPdfSomaGetPath = '/api/Excel/PDF_SOMA';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelPdfSomaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelPdfSomaGet$Response(params?: {
    payslip_id?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelPdfSomaGetPath, 'get');
    if (params) {
      rb.query('payslip_id', params.payslip_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelPdfSomaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelPdfSomaGet(params?: {
    payslip_id?: string;
  }): Observable<Blob> {

    return this.apiExcelPdfSomaGet$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
